/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as EnterpriseRouteImport } from './routes/enterprise'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductsCodespringforgeRouteImport } from './routes/products/codespringforge'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin/subscriptions'
import { Route as AdminHealthRouteImport } from './routes/admin/health'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminActivityRouteImport } from './routes/admin/activity'
import { Route as AdminGovernanceRouteImport } from './routes/admin/governance'
import { Route as AdminReliabilityRouteImport } from './routes/admin/reliability'
import { Route as AdminComplianceRouteImport } from './routes/admin/compliance'
import { Route as AdminSystemRouteImport } from './routes/admin/system'
import { Route as AdminAffiliatesRouteImport } from './routes/admin/affiliates'
import { Route as AuthenticatedTeamRouteImport } from './routes/_authenticated/team'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedUsageRouteImport } from './routes/_authenticated/usage'
import { Route as AuthenticatedGovernanceRouteImport } from './routes/_authenticated/governance'
import { Route as AuthenticatedPrdsRouteImport } from './routes/_authenticated/prds'
import { Route as AuthenticatedRepositoriesIndexRouteImport } from './routes/_authenticated/repositories/index'
import { Route as AuthenticatedRepositoriesRepoIdRouteImport } from './routes/_authenticated/repositories/$repoId'
import { Route as AuthenticatedPrdPrdIdRouteImport } from './routes/_authenticated/prd/$prdId'
import { Route as AuthenticatedRepositoriesRepoIdSecurityRouteImport } from './routes/_authenticated/repositories/$repoId.security'
import { Route as AuthenticatedRepositoriesRepoIdSddRouteImport } from './routes/_authenticated/repositories/$repoId.sdd'
import { Route as AuthenticatedRepositoriesRepoIdPrdRouteImport } from './routes/_authenticated/repositories/$repoId.prd'
import { Route as AuthenticatedRepositoriesRepoIdFeaturesRouteImport } from './routes/_authenticated/repositories/$repoId.features'
import { Route as AuthenticatedRepositoriesRepoIdAcfRouteImport } from './routes/_authenticated/repositories/$repoId.acf'
import { Route as AuthenticatedRepositoriesRepoIdSddSddIdRouteImport } from './routes/_authenticated/repositories/$repoId/sdd/$sddId'
import { Route as AuthenticatedRepositoriesRepoIdAcfSessionIdRouteImport } from './routes/_authenticated/repositories/$repoId/acf/$sessionId'
import { Route as AuthCallbackSuccessRouteImport } from './routes/auth/callback/success'
import { Route as AuthCallbackErrorRouteImport } from './routes/auth/callback/error'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DocsApiRouteImport } from './routes/docs/api'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ProductsAICodeForgeRouteImport } from './routes/products/aicodeforge'
import { Route as ProductsSDDForgeRouteImport } from './routes/products/sdd-forge'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SupportRouteImport } from './routes/support'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as AdminRevenueControlCenterRouteImport } from './routes/admin/revenue-control-center'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AffiliatesRoute = AffiliatesRouteImport.update({
  id: '/affiliates',
  path: '/affiliates',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const EnterpriseRoute = EnterpriseRouteImport.update({
  id: '/enterprise',
  path: '/enterprise',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsCodespringforgeRoute = ProductsCodespringforgeRouteImport.update({
  id: '/products/codespringforge',
  path: '/products/codespringforge',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsAICodeForgeRoute = ProductsAICodeForgeRouteImport.update({
  id: '/products/aicodeforge',
  path: '/products/aicodeforge',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsSDDForgeRoute = ProductsSDDForgeRouteImport.update({
  id: '/products/sdd-forge',
  path: '/products/sdd-forge',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const CareersRoute = CareersRouteImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsApiRoute = DocsApiRouteImport.update({
  id: '/docs/api',
  path: '/docs/api',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityRoute = CommunityRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
  id: '/admin/subscriptions',
  path: '/admin/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/admin/health',
  path: '/admin/health',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/admin/activity',
  path: '/admin/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGovernanceRoute = AdminGovernanceRouteImport.update({
  id: '/admin/governance',
  path: '/admin/governance',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReliabilityRoute = AdminReliabilityRouteImport.update({
  id: '/admin/reliability',
  path: '/admin/reliability',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminComplianceRoute = AdminComplianceRouteImport.update({
  id: '/admin/compliance',
  path: '/admin/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSystemRoute = AdminSystemRouteImport.update({
  id: '/admin/system',
  path: '/admin/system',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRevenueControlCenterRoute = AdminRevenueControlCenterRouteImport.update({
  id: '/admin/revenue-control-center',
  path: '/admin/revenue-control-center',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAffiliatesRoute = AdminAffiliatesRouteImport.update({
  id: '/admin/affiliates',
  path: '/admin/affiliates',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackSuccessRoute = AuthCallbackSuccessRouteImport.update({
  id: '/auth/callback/success',
  path: '/auth/callback/success',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackErrorRoute = AuthCallbackErrorRouteImport.update({
  id: '/auth/callback/error',
  path: '/auth/callback/error',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapRoute = SitemapRouteImport.update({
  id: '/sitemap',
  path: '/sitemap',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const RoadmapRoute = RoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTeamRoute = AuthenticatedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsageRoute = AuthenticatedUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGovernanceRoute = AuthenticatedGovernanceRouteImport.update({
  id: '/_authenticated/governance',
  path: '/governance',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPrdsRoute = AuthenticatedPrdsRouteImport.update({
  id: '/_authenticated/prds',
  path: '/prds',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRepositoriesIndexRoute =
  AuthenticatedRepositoriesIndexRouteImport.update({
    id: '/repositories/',
    path: '/repositories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdRoute =
  AuthenticatedRepositoriesRepoIdRouteImport.update({
    id: '/repositories/$repoId',
    path: '/repositories/$repoId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPrdPrdIdRoute = AuthenticatedPrdPrdIdRouteImport.update({
  id: '/prd/$prdId',
  path: '/prd/$prdId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRepositoriesRepoIdSecurityRoute =
  AuthenticatedRepositoriesRepoIdSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdSddRoute =
  AuthenticatedRepositoriesRepoIdSddRouteImport.update({
    id: '/sdd',
    path: '/sdd',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdPrdRoute =
  AuthenticatedRepositoriesRepoIdPrdRouteImport.update({
    id: '/prd',
    path: '/prd',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdFeaturesRoute =
  AuthenticatedRepositoriesRepoIdFeaturesRouteImport.update({
    id: '/features',
    path: '/features',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdAcfRoute =
  AuthenticatedRepositoriesRepoIdAcfRouteImport.update({
    id: '/acf',
    path: '/acf',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdSddSddIdRoute =
  AuthenticatedRepositoriesRepoIdSddSddIdRouteImport.update({
    id: '/$sddId',
    path: '/$sddId',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdSddRoute,
  } as any)
const AuthenticatedRepositoriesRepoIdAcfSessionIdRoute =
  AuthenticatedRepositoriesRepoIdAcfSessionIdRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => AuthenticatedRepositoriesRepoIdAcfRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/affiliates': typeof AffiliatesRoute
  '/contact': typeof ContactRoute
  '/enterprise': typeof EnterpriseRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRoute
  '/pricing': typeof PricingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/team': typeof AuthenticatedTeamRoute
  '/usage': typeof AuthenticatedUsageRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/affiliates': typeof AdminAffiliatesRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/compliance': typeof AdminComplianceRoute
  '/admin/governance': typeof AdminGovernanceRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/reliability': typeof AdminReliabilityRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/system': typeof AdminSystemRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin': typeof AdminIndexRoute
  '/products': typeof ProductsIndexRoute
  '/products/codespringforge': typeof ProductsCodespringforgeRoute
  '/prd/$prdId': typeof AuthenticatedPrdPrdIdRoute
  '/repositories/$repoId': typeof AuthenticatedRepositoriesRepoIdRouteWithChildren
  '/repositories': typeof AuthenticatedRepositoriesIndexRoute
  '/repositories/$repoId/acf': typeof AuthenticatedRepositoriesRepoIdAcfRouteWithChildren
  '/repositories/$repoId/features': typeof AuthenticatedRepositoriesRepoIdFeaturesRoute
  '/repositories/$repoId/prd': typeof AuthenticatedRepositoriesRepoIdPrdRoute
  '/repositories/$repoId/sdd': typeof AuthenticatedRepositoriesRepoIdSddRouteWithChildren
  '/repositories/$repoId/security': typeof AuthenticatedRepositoriesRepoIdSecurityRoute
  '/repositories/$repoId/acf/$sessionId': typeof AuthenticatedRepositoriesRepoIdAcfSessionIdRoute
  '/repositories/$repoId/sdd/$sddId': typeof AuthenticatedRepositoriesRepoIdSddSddIdRoute
  '/auth/callback/success': typeof AuthCallbackSuccessRoute
  '/auth/callback/error': typeof AuthCallbackErrorRoute
  '/products/aicodeforge': typeof ProductsAICodeForgeRoute
  '/products/sdd-forge': typeof ProductsSDDForgeRoute
  '/changelog': typeof ChangelogRoute
  '/blog': typeof BlogRoute
  '/careers': typeof CareersRoute
  '/docs': typeof DocsRoute
  '/docs/api': typeof DocsApiRoute
  '/community': typeof CommunityRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/security': typeof SecurityRoute
  '/demo': typeof DemoRoute
  '/sitemap': typeof SitemapRoute
  '/status': typeof StatusRoute
  '/support': typeof SupportRoute
  '/roadmap': typeof RoadmapRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/affiliates': typeof AffiliatesRoute
  '/contact': typeof ContactRoute
  '/enterprise': typeof EnterpriseRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRoute
  '/pricing': typeof PricingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/team': typeof AuthenticatedTeamRoute
  '/usage': typeof AuthenticatedUsageRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/affiliates': typeof AdminAffiliatesRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/compliance': typeof AdminComplianceRoute
  '/admin/governance': typeof AdminGovernanceRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/reliability': typeof AdminReliabilityRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/system': typeof AdminSystemRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin': typeof AdminIndexRoute
  '/products': typeof ProductsIndexRoute
  '/products/codespringforge': typeof ProductsCodespringforgeRoute
  '/prd/$prdId': typeof AuthenticatedPrdPrdIdRoute
  '/repositories/$repoId': typeof AuthenticatedRepositoriesRepoIdRouteWithChildren
  '/repositories': typeof AuthenticatedRepositoriesIndexRoute
  '/repositories/$repoId/acf': typeof AuthenticatedRepositoriesRepoIdAcfRouteWithChildren
  '/repositories/$repoId/features': typeof AuthenticatedRepositoriesRepoIdFeaturesRoute
  '/repositories/$repoId/prd': typeof AuthenticatedRepositoriesRepoIdPrdRoute
  '/repositories/$repoId/sdd': typeof AuthenticatedRepositoriesRepoIdSddRouteWithChildren
  '/repositories/$repoId/security': typeof AuthenticatedRepositoriesRepoIdSecurityRoute
  '/repositories/$repoId/acf/$sessionId': typeof AuthenticatedRepositoriesRepoIdAcfSessionIdRoute
  '/repositories/$repoId/sdd/$sddId': typeof AuthenticatedRepositoriesRepoIdSddSddIdRoute
  '/auth/callback/success': typeof AuthCallbackSuccessRoute
  '/auth/callback/error': typeof AuthCallbackErrorRoute
  '/products/aicodeforge': typeof ProductsAICodeForgeRoute
  '/products/sdd-forge': typeof ProductsSDDForgeRoute
  '/changelog': typeof ChangelogRoute
  '/blog': typeof BlogRoute
  '/careers': typeof CareersRoute
  '/docs': typeof DocsRoute
  '/docs/api': typeof DocsApiRoute
  '/community': typeof CommunityRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/security': typeof SecurityRoute
  '/demo': typeof DemoRoute
  '/sitemap': typeof SitemapRoute
  '/status': typeof StatusRoute
  '/support': typeof SupportRoute
  '/roadmap': typeof RoadmapRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_marketing': typeof MarketingRoute
  '/about': typeof AboutRoute
  '/affiliates': typeof AffiliatesRoute
  '/contact': typeof ContactRoute
  '/enterprise': typeof EnterpriseRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRoute
  '/pricing': typeof PricingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/billing': typeof AuthenticatedBillingRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/team': typeof AuthenticatedTeamRoute
  '/_authenticated/usage': typeof AuthenticatedUsageRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/affiliates': typeof AdminAffiliatesRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/compliance': typeof AdminComplianceRoute
  '/admin/governance': typeof AdminGovernanceRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/reliability': typeof AdminReliabilityRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRoute
  '/admin/system': typeof AdminSystemRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/products/codespringforge': typeof ProductsCodespringforgeRoute
  '/_authenticated/prd/$prdId': typeof AuthenticatedPrdPrdIdRoute
  '/_authenticated/repositories/$repoId': typeof AuthenticatedRepositoriesRepoIdRouteWithChildren
  '/_authenticated/repositories/': typeof AuthenticatedRepositoriesIndexRoute
  '/_authenticated/repositories/$repoId/acf': typeof AuthenticatedRepositoriesRepoIdAcfRouteWithChildren
  '/_authenticated/repositories/$repoId/features': typeof AuthenticatedRepositoriesRepoIdFeaturesRoute
  '/_authenticated/repositories/$repoId/prd': typeof AuthenticatedRepositoriesRepoIdPrdRoute
  '/_authenticated/repositories/$repoId/sdd': typeof AuthenticatedRepositoriesRepoIdSddRouteWithChildren
  '/_authenticated/repositories/$repoId/security': typeof AuthenticatedRepositoriesRepoIdSecurityRoute
  '/_authenticated/repositories/$repoId/acf/$sessionId': typeof AuthenticatedRepositoriesRepoIdAcfSessionIdRoute
  '/_authenticated/repositories/$repoId/sdd/$sddId': typeof AuthenticatedRepositoriesRepoIdSddSddIdRoute
  '/auth/callback/success': typeof AuthCallbackSuccessRoute
  '/auth/callback/error': typeof AuthCallbackErrorRoute
  '/products/aicodeforge': typeof ProductsAICodeForgeRoute
  '/products/sdd-forge': typeof ProductsSDDForgeRoute
  '/changelog': typeof ChangelogRoute
  '/blog': typeof BlogRoute
  '/careers': typeof CareersRoute
  '/docs': typeof DocsRoute
  '/docs/api': typeof DocsApiRoute
  '/community': typeof CommunityRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/security': typeof SecurityRoute
  '/demo': typeof DemoRoute
  '/sitemap': typeof SitemapRoute
  '/status': typeof StatusRoute
  '/support': typeof SupportRoute
  '/roadmap': typeof RoadmapRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/affiliates'
    | '/contact'
    | '/enterprise'
    | '/forgot-password'
    | '/login'
    | '/platform'
    | '/pricing'
    | '/register'
    | '/reset-password'
    | '/billing'
    | '/dashboard'
    | '/settings'
    | '/team'
    | '/usage'
    | '/admin/activity'
    | '/admin/affiliates'
    | '/admin/analytics'
    | '/admin/compliance'
    | '/admin/governance'
    | '/admin/health'
    | '/admin/reliability'
    | '/admin/subscriptions'
    | '/admin/system'
    | '/admin/users'
    | '/admin'
    | '/products'
    | '/products/codespringforge'
    | '/prd/$prdId'
    | '/repositories/$repoId'
    | '/repositories'
    | '/repositories/$repoId/acf'
    | '/repositories/$repoId/features'
    | '/repositories/$repoId/prd'
    | '/repositories/$repoId/sdd'
    | '/repositories/$repoId/security'
    | '/repositories/$repoId/acf/$sessionId'
    | '/repositories/$repoId/sdd/$sddId'
    | '/auth/callback/success'
    | '/auth/callback/error'
    | '/products/aicodeforge'
    | '/products/sdd-forge'
    | '/changelog'
    | '/blog'
    | '/careers'
    | '/docs'
    | '/docs/api'
    | '/community'
    | '/privacy'
    | '/terms'
    | '/security'
    | '/demo'
    | '/sitemap'
    | '/status'
    | '/support'
    | '/roadmap'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/affiliates'
    | '/contact'
    | '/enterprise'
    | '/forgot-password'
    | '/login'
    | '/platform'
    | '/pricing'
    | '/register'
    | '/reset-password'
    | '/billing'
    | '/dashboard'
    | '/settings'
    | '/team'
    | '/usage'
    | '/admin/activity'
    | '/admin/affiliates'
    | '/admin/analytics'
    | '/admin/compliance'
    | '/admin/governance'
    | '/admin/health'
    | '/admin/reliability'
    | '/admin/subscriptions'
    | '/admin/system'
    | '/admin/users'
    | '/admin'
    | '/products'
    | '/products/codespringforge'
    | '/prd/$prdId'
    | '/repositories/$repoId'
    | '/repositories'
    | '/repositories/$repoId/acf'
    | '/repositories/$repoId/features'
    | '/repositories/$repoId/prd'
    | '/repositories/$repoId/sdd'
    | '/repositories/$repoId/security'
    | '/repositories/$repoId/acf/$sessionId'
    | '/repositories/$repoId/sdd/$sddId'
    | '/auth/callback/success'
    | '/auth/callback/error'
    | '/products/aicodeforge'
    | '/products/sdd-forge'
    | '/changelog'
    | '/blog'
    | '/careers'
    | '/docs'
    | '/docs/api'
    | '/community'
    | '/privacy'
    | '/terms'
    | '/security'
    | '/demo'
    | '/sitemap'
    | '/status'
    | '/support'
    | '/roadmap'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_marketing'
    | '/about'
    | '/affiliates'
    | '/contact'
    | '/enterprise'
    | '/forgot-password'
    | '/login'
    | '/platform'
    | '/pricing'
    | '/register'
    | '/reset-password'
    | '/_authenticated/billing'
    | '/_authenticated/dashboard'
    | '/_authenticated/settings'
    | '/_authenticated/team'
    | '/_authenticated/usage'
    | '/admin/activity'
    | '/admin/affiliates'
    | '/admin/analytics'
    | '/admin/compliance'
    | '/admin/governance'
    | '/admin/health'
    | '/admin/reliability'
    | '/admin/subscriptions'
    | '/admin/system'
    | '/admin/users'
    | '/admin/'
    | '/products/'
    | '/products/codespringforge'
    | '/_authenticated/prd/$prdId'
    | '/_authenticated/repositories/$repoId'
    | '/_authenticated/repositories/'
    | '/_authenticated/repositories/$repoId/acf'
    | '/_authenticated/repositories/$repoId/features'
    | '/_authenticated/repositories/$repoId/prd'
    | '/_authenticated/repositories/$repoId/sdd'
    | '/_authenticated/repositories/$repoId/security'
    | '/_authenticated/repositories/$repoId/acf/$sessionId'
    | '/_authenticated/repositories/$repoId/sdd/$sddId'
    | '/auth/callback/success'
    | '/auth/callback/error'
    | '/products/aicodeforge'
    | '/products/sdd-forge'
    | '/changelog'
    | '/blog'
    | '/careers'
    | '/docs'
    | '/docs/api'
    | '/community'
    | '/privacy'
    | '/terms'
    | '/security'
    | '/demo'
    | '/sitemap'
    | '/status'
    | '/support'
    | '/roadmap'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  MarketingRoute: typeof MarketingRoute
  AboutRoute: typeof AboutRoute
  AffiliatesRoute: typeof AffiliatesRoute
  ContactRoute: typeof ContactRoute
  EnterpriseRoute: typeof EnterpriseRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PlatformRoute: typeof PlatformRoute
  PricingRoute: typeof PricingRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AdminActivityRoute: typeof AdminActivityRoute
  AdminAffiliatesRoute: typeof AdminAffiliatesRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminComplianceRoute: typeof AdminComplianceRoute
  AdminGovernanceRoute: typeof AdminGovernanceRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminReliabilityRoute: typeof AdminReliabilityRoute
  AdminSubscriptionsRoute: typeof AdminSubscriptionsRoute
  AdminSystemRoute: typeof AdminSystemRoute
  AdminRevenueControlCenterRoute: typeof AdminRevenueControlCenterRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ProductsCodespringforgeRoute: typeof ProductsCodespringforgeRoute
  ProductsAICodeForgeRoute: typeof ProductsAICodeForgeRoute
  ProductsSDDForgeRoute: typeof ProductsSDDForgeRoute
  ChangelogRoute: typeof ChangelogRoute
  BlogRoute: typeof BlogRoute
  CareersRoute: typeof CareersRoute
  DocsRoute: typeof DocsRoute
  DocsApiRoute: typeof DocsApiRoute
  CommunityRoute: typeof CommunityRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  SecurityRoute: typeof SecurityRoute
  DemoRoute: typeof DemoRoute
  AuthCallbackSuccessRoute: typeof AuthCallbackSuccessRoute
  AuthCallbackErrorRoute: typeof AuthCallbackErrorRoute
  SitemapRoute: typeof SitemapRoute
  StatusRoute: typeof StatusRoute
  SupportRoute: typeof SupportRoute
  RoadmapRoute: typeof RoadmapRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enterprise': {
      id: '/enterprise'
      path: '/enterprise'
      fullPath: '/enterprise'
      preLoaderRoute: typeof EnterpriseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/affiliates': {
      id: '/affiliates'
      path: '/affiliates'
      fullPath: '/affiliates'
      preLoaderRoute: typeof AffiliatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/codespringforge': {
      id: '/products/codespringforge'
      path: '/products/codespringforge'
      fullPath: '/products/codespringforge'
      preLoaderRoute: typeof ProductsCodespringforgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/aicodeforge': {
      id: '/products/aicodeforge'
      path: '/products/aicodeforge'
      fullPath: '/products/aicodeforge'
      preLoaderRoute: typeof ProductsAICodeForgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/sdd-forge': {
      id: '/products/sdd-forge'
      path: '/products/sdd-forge'
      fullPath: '/products/sdd-forge'
      preLoaderRoute: typeof ProductsSDDForgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/careers': {
      id: '/careers'
      path: '/careers'
      fullPath: '/careers'
      preLoaderRoute: typeof CareersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/api': {
      id: '/docs/api'
      path: '/docs/api'
      fullPath: '/docs/api'
      preLoaderRoute: typeof DocsApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/subscriptions': {
      id: '/admin/subscriptions'
      path: '/admin/subscriptions'
      fullPath: '/admin/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/admin/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/admin/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/affiliates': {
      id: '/admin/affiliates'
      path: '/admin/affiliates'
      fullPath: '/admin/affiliates'
      preLoaderRoute: typeof AdminAffiliatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/compliance': {
      id: '/admin/compliance'
      path: '/admin/compliance'
      fullPath: '/admin/compliance'
      preLoaderRoute: typeof AdminComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/governance': {
      id: '/admin/governance'
      path: '/admin/governance'
      fullPath: '/admin/governance'
      preLoaderRoute: typeof AdminGovernanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reliability': {
      id: '/admin/reliability'
      path: '/admin/reliability'
      fullPath: '/admin/reliability'
      preLoaderRoute: typeof AdminReliabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/system': {
      id: '/admin/system'
      path: '/admin/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AdminSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/team': {
      id: '/_authenticated/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthenticatedTeamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing': {
      id: '/_authenticated/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/usage': {
      id: '/_authenticated/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof AuthenticatedUsageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/governance': {
      id: '/_authenticated/governance'
      path: '/governance'
      fullPath: '/governance'
      preLoaderRoute: typeof AuthenticatedGovernanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prds': {
      id: '/_authenticated/prds'
      path: '/prds'
      fullPath: '/prds'
      preLoaderRoute: typeof AuthenticatedPrdsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/repositories/': {
      id: '/_authenticated/repositories/'
      path: '/repositories'
      fullPath: '/repositories'
      preLoaderRoute: typeof AuthenticatedRepositoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/repositories/$repoId': {
      id: '/_authenticated/repositories/$repoId'
      path: '/repositories/$repoId'
      fullPath: '/repositories/$repoId'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prd/$prdId': {
      id: '/_authenticated/prd/$prdId'
      path: '/prd/$prdId'
      fullPath: '/prd/$prdId'
      preLoaderRoute: typeof AuthenticatedPrdPrdIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/repositories/$repoId/security': {
      id: '/_authenticated/repositories/$repoId/security'
      path: '/security'
      fullPath: '/repositories/$repoId/security'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdSecurityRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdRoute
    }
    '/_authenticated/repositories/$repoId/sdd': {
      id: '/_authenticated/repositories/$repoId/sdd'
      path: '/sdd'
      fullPath: '/repositories/$repoId/sdd'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdSddRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdRoute
    }
    '/_authenticated/repositories/$repoId/prd': {
      id: '/_authenticated/repositories/$repoId/prd'
      path: '/prd'
      fullPath: '/repositories/$repoId/prd'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdPrdRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdRoute
    }
    '/_authenticated/repositories/$repoId/features': {
      id: '/_authenticated/repositories/$repoId/features'
      path: '/features'
      fullPath: '/repositories/$repoId/features'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdFeaturesRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdRoute
    }
    '/_authenticated/repositories/$repoId/acf': {
      id: '/_authenticated/repositories/$repoId/acf'
      path: '/acf'
      fullPath: '/repositories/$repoId/acf'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdAcfRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdRoute
    }
    '/_authenticated/repositories/$repoId/sdd/$sddId': {
      id: '/_authenticated/repositories/$repoId/sdd/$sddId'
      path: '/$sddId'
      fullPath: '/repositories/$repoId/sdd/$sddId'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdSddSddIdRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdSddRoute
    }
    '/_authenticated/repositories/$repoId/acf/$sessionId': {
      id: '/_authenticated/repositories/$repoId/acf/$sessionId'
      path: '/$sessionId'
      fullPath: '/repositories/$repoId/acf/$sessionId'
      preLoaderRoute: typeof AuthenticatedRepositoriesRepoIdAcfSessionIdRouteImport
      parentRoute: typeof AuthenticatedRepositoriesRepoIdAcfRoute
    }
    '/auth/callback/success': {
      id: '/auth/callback/success'
      path: '/auth/callback/success'
      fullPath: '/auth/callback/success'
      preLoaderRoute: typeof AuthCallbackSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback/error': {
      id: '/auth/callback/error'
      path: '/auth/callback/error'
      fullPath: '/auth/callback/error'
      preLoaderRoute: typeof AuthCallbackErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap': {
      id: '/sitemap'
      path: '/sitemap'
      fullPath: '/sitemap'
      preLoaderRoute: typeof SitemapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roadmap': {
      id: '/roadmap'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof RoadmapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/revenue-control-center': {
      id: '/admin/revenue-control-center'
      path: '/admin/revenue-control-center'
      fullPath: '/admin/revenue-control-center'
      preLoaderRoute: typeof AdminRevenueControlCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthenticatedRepositoriesRepoIdAcfRouteChildren {
  AuthenticatedRepositoriesRepoIdAcfSessionIdRoute: typeof AuthenticatedRepositoriesRepoIdAcfSessionIdRoute
}

const AuthenticatedRepositoriesRepoIdAcfRouteChildren: AuthenticatedRepositoriesRepoIdAcfRouteChildren =
  {
    AuthenticatedRepositoriesRepoIdAcfSessionIdRoute:
      AuthenticatedRepositoriesRepoIdAcfSessionIdRoute,
  }

const AuthenticatedRepositoriesRepoIdAcfRouteWithChildren =
  AuthenticatedRepositoriesRepoIdAcfRoute._addFileChildren(
    AuthenticatedRepositoriesRepoIdAcfRouteChildren,
  )

interface AuthenticatedRepositoriesRepoIdSddRouteChildren {
  AuthenticatedRepositoriesRepoIdSddSddIdRoute: typeof AuthenticatedRepositoriesRepoIdSddSddIdRoute
}

const AuthenticatedRepositoriesRepoIdSddRouteChildren: AuthenticatedRepositoriesRepoIdSddRouteChildren =
  {
    AuthenticatedRepositoriesRepoIdSddSddIdRoute:
      AuthenticatedRepositoriesRepoIdSddSddIdRoute,
  }

const AuthenticatedRepositoriesRepoIdSddRouteWithChildren =
  AuthenticatedRepositoriesRepoIdSddRoute._addFileChildren(
    AuthenticatedRepositoriesRepoIdSddRouteChildren,
  )

interface AuthenticatedRepositoriesRepoIdRouteChildren {
  AuthenticatedRepositoriesRepoIdAcfRoute: typeof AuthenticatedRepositoriesRepoIdAcfRouteWithChildren
  AuthenticatedRepositoriesRepoIdFeaturesRoute: typeof AuthenticatedRepositoriesRepoIdFeaturesRoute
  AuthenticatedRepositoriesRepoIdPrdRoute: typeof AuthenticatedRepositoriesRepoIdPrdRoute
  AuthenticatedRepositoriesRepoIdSddRoute: typeof AuthenticatedRepositoriesRepoIdSddRouteWithChildren
  AuthenticatedRepositoriesRepoIdSecurityRoute: typeof AuthenticatedRepositoriesRepoIdSecurityRoute
}

const AuthenticatedRepositoriesRepoIdRouteChildren: AuthenticatedRepositoriesRepoIdRouteChildren =
  {
    AuthenticatedRepositoriesRepoIdAcfRoute:
      AuthenticatedRepositoriesRepoIdAcfRouteWithChildren,
    AuthenticatedRepositoriesRepoIdFeaturesRoute:
      AuthenticatedRepositoriesRepoIdFeaturesRoute,
    AuthenticatedRepositoriesRepoIdPrdRoute:
      AuthenticatedRepositoriesRepoIdPrdRoute,
    AuthenticatedRepositoriesRepoIdSddRoute:
      AuthenticatedRepositoriesRepoIdSddRouteWithChildren,
    AuthenticatedRepositoriesRepoIdSecurityRoute:
      AuthenticatedRepositoriesRepoIdSecurityRoute,
  }

const AuthenticatedRepositoriesRepoIdRouteWithChildren =
  AuthenticatedRepositoriesRepoIdRoute._addFileChildren(
    AuthenticatedRepositoriesRepoIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedBillingRoute: typeof AuthenticatedBillingRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedTeamRoute: typeof AuthenticatedTeamRoute
  AuthenticatedUsageRoute: typeof AuthenticatedUsageRoute
  AuthenticatedGovernanceRoute: typeof AuthenticatedGovernanceRoute
  AuthenticatedPrdsRoute: typeof AuthenticatedPrdsRoute
  AuthenticatedPrdPrdIdRoute: typeof AuthenticatedPrdPrdIdRoute
  AuthenticatedRepositoriesRepoIdRoute: typeof AuthenticatedRepositoriesRepoIdRouteWithChildren
  AuthenticatedRepositoriesIndexRoute: typeof AuthenticatedRepositoriesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBillingRoute: AuthenticatedBillingRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedTeamRoute: AuthenticatedTeamRoute,
  AuthenticatedUsageRoute: AuthenticatedUsageRoute,
  AuthenticatedGovernanceRoute: AuthenticatedGovernanceRoute,
  AuthenticatedPrdsRoute: AuthenticatedPrdsRoute,
  AuthenticatedPrdPrdIdRoute: AuthenticatedPrdPrdIdRoute,
  AuthenticatedRepositoriesRepoIdRoute:
    AuthenticatedRepositoriesRepoIdRouteWithChildren,
  AuthenticatedRepositoriesIndexRoute: AuthenticatedRepositoriesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  MarketingRoute: MarketingRoute,
  AboutRoute: AboutRoute,
  AffiliatesRoute: AffiliatesRoute,
  ContactRoute: ContactRoute,
  EnterpriseRoute: EnterpriseRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PlatformRoute: PlatformRoute,
  PricingRoute: PricingRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AdminActivityRoute: AdminActivityRoute,
  AdminAffiliatesRoute: AdminAffiliatesRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminComplianceRoute: AdminComplianceRoute,
  AdminGovernanceRoute: AdminGovernanceRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminReliabilityRoute: AdminReliabilityRoute,
  AdminSubscriptionsRoute: AdminSubscriptionsRoute,
  AdminSystemRoute: AdminSystemRoute,
  AdminRevenueControlCenterRoute: AdminRevenueControlCenterRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ProductsCodespringforgeRoute: ProductsCodespringforgeRoute,
  ProductsAICodeForgeRoute: ProductsAICodeForgeRoute,
  ProductsSDDForgeRoute: ProductsSDDForgeRoute,
  ChangelogRoute: ChangelogRoute,
  BlogRoute: BlogRoute,
  CareersRoute: CareersRoute,
  DocsRoute: DocsRoute,
  DocsApiRoute: DocsApiRoute,
  CommunityRoute: CommunityRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  SecurityRoute: SecurityRoute,
  DemoRoute: DemoRoute,
  AuthCallbackSuccessRoute: AuthCallbackSuccessRoute,
  AuthCallbackErrorRoute: AuthCallbackErrorRoute,
  SitemapRoute: SitemapRoute,
  StatusRoute: StatusRoute,
  SupportRoute: SupportRoute,
  RoadmapRoute: RoadmapRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
